import { find, map } from 'lodash';

import { UPDATE_USER_INFO_SUCCESS } from '@/constants';
import { cookieSetItem } from '@/global/cookie';
import * as constants from './Message.constants';
import * as services from './Message.service';

const state = {
  messageCount: 0,
  messageList: [],
  isRequest: false,
};

const mutations = {
  [constants.GET_IM_TOKEN_SUCCESS](state, data) {
    // state.isRequest = data;
    // console.log(data);
    cookieSetItem('uid', data.accId);
    cookieSetItem('sdktoken', data.token);
  },

  [constants.GET_MESSAGES_SUCCESS](state, messages) {
    if (undefined !== messages) {
      state.messageCount = messages.count;
      state.messageList = messages.list;
    }
  },

  [constants.READ_MESSAGES_SUCCESS](state, messageId) {
    const messageRead = find(state.messageList, (message) => messageId === message.messageId);
    messageRead.isCheck = true;
    state.messageList = [...state.messageList];
  },

  [constants.READ_ALL_MESSAGES_SUCCESS](state) {
    state.messageList = map(state.messageList, (message) => ({
      ...message,
      isCheck: true,
    }));
  },

  [constants.SET_IS_REQUEST_STATUS](state, status) {
    state.isRequest = status;
  },
};

const actions = {
  async getIMToken({ commit }, payload) {
    const res = await services.getIMToken(payload);
    commit(constants.GET_IM_TOKEN_SUCCESS, res.data.data);
  },

  async getMessages({ commit }, payload) {
    commit(constants.SET_IS_REQUEST_STATUS, true);
    const res = await services.getMessages(payload);
    commit(constants.GET_MESSAGES_SUCCESS, res.data.data);
    commit(constants.SET_IS_REQUEST_STATUS, false);
  },

  async readMessage({ commit }, payload) {
    const res = await services.readMessage(payload);
    commit(constants.READ_MESSAGES_SUCCESS, payload.messageId);
    commit(
      UPDATE_USER_INFO_SUCCESS,
      {
        hasNewMessages: res.data.data.hasNewMessages,
      },
      { root: true }
    );
  },

  async readAllMessage({ commit }) {
    await services.readAllMessage();
    commit(constants.READ_ALL_MESSAGES_SUCCESS);
    commit(
      UPDATE_USER_INFO_SUCCESS,
      {
        hasNewMessages: false,
      },
      { root: true }
    );
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
